// extracted by mini-css-extract-plugin
module.exports = {"workshop":"Workshop_workshop__1szcs","workshop-text":"Workshop_workshop-text__1hrg0"};